import React from 'react';
import { Grid, Typography } from '@mui/material';
import { ChainSvg } from '../../../../assets';
import { styles } from '../../../../components/landing-page-wrapper/landing-page-wrapper-helper';
import { lifegraphExplorerEmptyStateStyles } from './lifegraph-explorer-helper';
import { Button } from '@biq/apex-ui';

interface UnsupportedLGQueryProps {
    isCanvasHeightSmall?: boolean;
    handleClick: () => void;
}

export const UnsupportedLGQuery = ({
    isCanvasHeightSmall,
    handleClick,
}: UnsupportedLGQueryProps): React.JSX.Element => {
    return (
        <Grid
            sx={{
                ...lifegraphExplorerEmptyStateStyles.mainContainer,
                ...(isCanvasHeightSmall &&
                    lifegraphExplorerEmptyStateStyles.paddingStyles),
            }}
        >
            <Grid>
                <img
                    style={lifegraphExplorerEmptyStateStyles.errorImage}
                    src={ChainSvg}
                    alt='empty-state'
                />
            </Grid>
            <Grid sx={lifegraphExplorerEmptyStateStyles.headerTextContainer}>
                <Typography sx={styles.emptyHeadingText}>
                    Not supported in this view, use the TQL Editor
                </Typography>
            </Grid>
            <Grid sx={lifegraphExplorerEmptyStateStyles.subheaderTextContainer}>
                <Button size='large' onClick={handleClick}>
                    OPEN TQL Editor
                </Button>
            </Grid>
        </Grid>
    );
};
